import React from 'react'
import { Row, Col } from 'antd'
import { Chart } from 'react-google-charts'
import './overview-chart.scss'

const OverviewChart = ({ overviewChartData, productsTotalCost }) => {
    let data = new window.google.visualization.DataTable()
    let formatter = new window.google.visualization.NumberFormat({
        pattern: '$,###.##',
        fractionDigits: 2,
    })

    data.addColumn('string', 'Topping')
    data.addColumn('number', 'Slices')

    if (overviewChartData.length > 0) {
        data.addRows(overviewChartData)
        formatter.format(data, 1)
    }

    let totalCost = 0
    productsTotalCost.map(product => {
        totalCost += product.total_cost
    })
    totalCost = totalCost ? totalCost.toFixed(2) : 0
    return (
        <div>
            {/* <Row type="flex" gutter={30} className="chart-container">
            <Col span={12}></Col>
            <Col span={6}>
                <h2>Total Cost</h2>
            </Col>
            <Col span={6}>
                <div className="total-cost-div">
                    ${totalCost}
                </div>
            </Col>
        </Row> */}
            <div className="chart-center-section">
                <Row>
                    <Col span={24}>
                        <h2>Cost/Usage</h2>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <h1>26%</h1>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} />
                </Row>
                <Row>
                    <Col span={24}>
                        <h3>$28.53</h3>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <h2>AWS Data Transfer</h2>
                    </Col>
                </Row>
            </div>
            <Chart
                chartType="PieChart"
                data={data}
                options={{
                    pieHole: 0.4,
                    sliceVisibilityThreshold: 0.00000000000000000001,
                    chartArea: {
                        left: 20,
                        top: 40,
                        width: '85%',
                        height: '85%',
                    },
                    legend: {
                        position: 'right',
                        alignment: 'center',
                        textStyle: { color: '#363d4d', fontSize: 15 },
                    },
                    fontName: 'Muli',
                    fontSize: 15,
                    tooltip: {
                        textStyle: { color: '#000', fontSize: 16 },
                    },
                }}
                graph_id="PieChart"
                width="90%"
                height="420px"
                legend_toggle
            />
        </div>
    )
}

export default OverviewChart
